import graphql__ad0893b73356c6ef4ce1 from "./__generated__/MarketingEmailsViewQuery.graphql.ts";import * as React from "react";
import {useState, useEffect, useCallback} from "react";
import Panel from "./presentational/Panel";
import {usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import Headline from "./presentational/Headline";
import {faPlusCircle} from "@fortawesome/pro-regular-svg-icons";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import ActionButton from "./presentational/button/ActionButton";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import ListSearch from "./presentational/ListSearch";
import MarketingEmailList from "./MarketingEmailList";
import CreateMarketingEmailDialog from "./dialog/CreateMarketingEmailDialog";
import type {MarketingEmailsViewQuery as MarketingEmailsViewQueryType} from "./__generated__/MarketingEmailsViewQuery.graphql";
import {useSearchParams} from "react-router-dom";
import {useOutletContext} from "react-router";
import {useIntl} from "react-intl";

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type Props = {};

type MarketingEmailsViewProps = ConnectedProps<typeof connector> & Props;

const MarketingEmailsView: React.FC<MarketingEmailsViewProps> = (props) => {
    const intl = useIntl();
    const prepared: any = useOutletContext();
    const {dispatchShowModal, dispatchHideModal} = props
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
    const [isSearching, setIsSearching] = useState(false);

    const query = usePreloadedQuery<MarketingEmailsViewQueryType>(
        graphql__ad0893b73356c6ef4ce1,
        prepared?.marketingEmailsQuery,
    );

    const updateURL = useCallback((term: string) => {
        const newParams = new URLSearchParams(searchParams);
        if (term.trim()) {
            newParams.set('search', term);
        } else {
            newParams.delete('search');
        }
        setSearchParams(newParams, { replace: true });
    }, [searchParams, setSearchParams]);

    const searchAPIDebounced = AwesomeDebouncePromise(
        (searchTerm: string) => {
            setSearchTerm(searchTerm);
            updateURL(searchTerm);
        },
        500
    );

    const handleSearchTermChange = (searchTerm: string) => {
        searchAPIDebounced(searchTerm);
    };

    useEffect(() => {
        const urlSearchTerm = searchParams.get('search') || '';
        setSearchTerm(urlSearchTerm);
    }, [searchParams]);

    // Check if the preloaded query is available
    if (!prepared || !prepared.marketingEmailsQuery) {
        return (
            <Panel>
                <div className="px-6 pt-6 pb-4">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="flex-1 min-w-0">
                            <Headline>{intl.formatMessage({id: 'view.marketingEmails.headline'})}</Headline>
                        </div>
                    </div>
                </div>
                <div className="text-center py-10">
                    <p className="text-gray-500">{intl.formatMessage({id: 'common.loading'})}</p>
                </div>
            </Panel>
        );
    }

    const showCreateMarketingEmailDialog = () => {
        dispatchShowModal({
            body: (<CreateMarketingEmailDialog handleCloseDialog={dispatchHideModal}/>)
        })
    };

    return (
        <Panel>
            <div className="px-6 pt-6 pb-4">
                <div className="md:flex md:items-center md:justify-between">
                    <div className="flex-1 min-w-0">
                        <Headline>{intl.formatMessage({id: 'view.marketingEmails.headline'})}</Headline>
                    </div>
                    <div className="mt-6 flex space-x-3 md:mt-0 md:ml-4">
                        <ActionButton icon={faPlusCircle} title={intl.formatMessage({id: 'view.marketingEmails.createButton'})} onClick={() => {
                            showCreateMarketingEmailDialog()
                        }}/>
                    </div>
                </div>
                <ListSearch
                    handleSearchTermChange={handleSearchTermChange}
                    placeholder={intl.formatMessage({id: 'view.marketingEmails.searchPlaceholder'})}
                    initialValue={searchTerm}
                    isLoading={isSearching}
                />
            </div>
            <MarketingEmailList
                queryRef={query}
                searchTerm={searchTerm}
                onLoadingChange={setIsSearching}
            />
        </Panel>
    )
}

export default connector(MarketingEmailsView);
